// ---------------------------------------------------------------------------
// Terms of Service re-acceptance feature
//
// These values are shared by the re-acceptance popup
// (ModalTermsReacceptance) and the signup flow (auth.duck.js), so they live
// in one neutral module instead of inside a React component.
// ---------------------------------------------------------------------------

// FEATURE FLAG
export const TERMS_REACCEPTANCE_ENABLED = true;

// The current version of the Terms of Service. When you publish new terms and
// want every existing user to agree again, bump this number (or change the
// string). A user is asked to agree until their saved `acceptedTermsVersion`
// matches this value.
//
// New users who sign up already agree to the terms via the signup checkbox,
// so signup stamps this same value on their protected data and they never see
// the popup.
export const LATEST_TERMS_VERSION = 2;
